export const formatHTML = (content: string): string => {
  return content.replace(/<a/g, '<a class="Link"')
}
